export default __webpack_public_path__ + "static/media/net.c0c1aabd.jpeg";